import * as types from '../mutation-types';
import {unionState, toDateTimeString} from '../helpers';

const state = () => ({
	news: [],
});

const actions = {
	fetchAll({commit}) {
		return axios.get('/api/news').then(response => {
			commit(types.STORE_NEWS, response.data);

			return response.data;
		});
	},

	fetch({commit}, {newsId}) {
		return axios.get(`/api/news/${newsId}`).then(response => {
			commit(types.STORE_ONE_NEWS, response.data);

			return response.data;
		});
	},

	create({commit}, {title, content, image, images}) {
		const formData = new FormData();
		formData.append('title', title);
		formData.append('content', content);
		formData.append('image', image);

		if (images && images.length > 0)
			for (let image of images)
				formData.append('images[]', image);
	
		return axios.post(`/api/news`, formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		}).then(response => {
			commit(types.STORE_ONE_NEWS, response.data);

			return response.data;
		});
	},

	update({commit}, {newsId, title, content, image, images}) {
		const formData = new FormData();
		formData.append('title', title);
		formData.append('content', content);

		if (image)
			formData.append('image', image);

		if (images && images.length > 0)
			for (let image of images)
				formData.append('images[]', image);

		formData.append('_method', 'PUT');
	
		return axios.post(`/api/news/${newsId}`, formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		}).then(response => {
			commit(types.STORE_ONE_NEWS, response.data);

			return response.data;
		});
	},

	delete({commit}, {newsId}) {
		return axios.delete(`/api/news/${newsId}`).then(response => {
			commit(types.DELETE_ONE_NEWS, newsId);
		});
	},

	restore({commit}, {newsId}) {
		return axios.patch(`/api/news/${newsId}`).then(response => {
			commit(types.RESTORE_ONE_NEWS, newsId);
		});
	}
};

const mutations = {
	[types.STORE_NEWS](state, news) {
		state.news = unionState(state.news, news);
	},

	[types.STORE_ONE_NEWS](state, news) {
		state.news = unionState(state.news, [news]);
	},

	[types.DELETE_ONE_NEWS](state, id) {
		const news = state.news.find(t => t.id === id);
		news.deleted_at = toDateTimeString(new Date());
	},

	[types.RESTORE_ONE_NEWS](state, id) {
		state.news = state.news.filter(t => t.id !== id);
	},
};

const getters = {
	getById: state => id => state.news.find(n => n.id === id),
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};